import { Table, TableProps } from 'antd'
import classNames from 'classnames'

import './EATable.css'

interface EATableProps<T> extends TableProps<T> {
  className?: string
  disabled?: boolean
}

const EATable = <T extends object>({ className, disabled = false, ...antdTableProps }: EATableProps<T>) => (
  <div
    style={{
      pointerEvents: disabled ? 'none' : 'auto',
      opacity: disabled ? 0.5 : 1
    }}
  >
    <Table
      bordered
      className={classNames('ea-table__container', className)}
      pagination={{
        hideOnSinglePage: true,
        pageSizeOptions: [10, 20, 50, 100],
        showSizeChanger: true
      }}
      {...antdTableProps}
    />
  </div>
)

export default EATable
